// extracted by mini-css-extract-plugin
export default {"main":"Slideclose_main__6Ejd3","iconsname":"Slideclose_iconsname__+2nxr"};